import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  padding: 10px;
  min-height: 300px;

  h3 {
    font-family: ManropeLight, sans-serif;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid ${(props) => props.theme.colors.inactive};
    padding-bottom: 10px;
  }

  .close-btn {
    width: 100px;
  }

  .audio-row {
    display: flex;
    gap: 25px;

    .name {
      width: 400px;
      margin: auto 0;
      font-size: 15px;
    }

    audio {
      height: 38px;
      width: 300px;
    }

    input {
      padding: 0;
      margin-left: 10px;
    }

    audio::-webkit-media-controls-play-button,
     audio::-webkit-media-controls-panel {
     background-color: ${(props) => props.theme.colors.inactive};
     }

    button {
      padding: 10px 5px;
      border: 1px solid ${(props) => props.theme.colors.inactive};
      border-radius: 12px;

      &:hover {
        border: 1px solid ${(props) => props.theme.colors.main_cta};
      }

      &:disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }
`;

export default {
  Wrapper,
};
